// Parse options choices to array of strings with the values
export const parseChoicesToArray = (choices) => choices.map(({ value }) => value);
